module.exports = __webpack_public_path__ + "img/IMG_9022_L_Foamcore_MockedUp.19fed094.jpg";